import {
  NozzleParameterFields,
  RocketPerformanceFields,
} from './RocketNozzleFields';

// The LEGACY single pane (feature-tree-windows flag OFF, kill-switch fallback).
// The field ROWS were factored into RocketNozzleFields so the exact same
// controls also render split across the "Nozzle Parameters"/"Rocket
// Performance" floating windows when the flag is ON; this component simply
// stacks both groups under their original section headers, preserving the
// original layout and behavior byte-for-byte.
export function SpaceContent({ enabled }: { enabled: boolean }) {
  return (
    <div>
      <img
        src="/rocket-hotfire-banner.png"
        alt="Rocket Hotfire"
        className="w-full rounded-lg object-cover"
      />
      <div className="mt-4">
        <p className="mb-2 text-xs font-semibold text-telekinesis-neutral-50">
          Parameters (CD de Laval Nozzle)
        </p>
        <NozzleParameterFields enabled={enabled} />

        <p className="mb-2 mt-4 text-xs font-semibold text-telekinesis-neutral-50">
          Theoretical Performance
        </p>
        <RocketPerformanceFields />
      </div>
    </div>
  );
}
